import { Button, COLORS, Typography } from '@musinsa/mds';
import styled, { CSSProperties } from 'styled-components';

const NotFound = () => <div>not found</div>;

const ApiErrorComponent = ({
  cssProperties,
  onClick,
}: {
  cssProperties?: CSSProperties;
  onClick?: () => void;
}) => (
  <S.Api.Wrap $cssProperties={cssProperties}>
    <Button size={36} variant="secondary" onClick={onClick}>
      <Typography size="14" colorScheme="black">
        새로고침
      </Typography>
    </Button>
  </S.Api.Wrap>
);

const GlobalErrorComponent = ({ onClick }: { onClick?: () => void }) => (
  <S.Layout.Wrap>
    <Typography variant="body14pxSemi" colorScheme="black">
      서비스 접속이 원활하지 않습니다.
    </Typography>
    <S.Layout.SubText>
      <Typography variant="body13pxReg" colorScheme="gray-600">
        잠시 후 다시 이용해 주세요.
      </Typography>
    </S.Layout.SubText>
    <S.Layout.ButtonWrap>
      <Button size={36} variant="secondary" onClick={onClick}>
        <Typography size={null} variant="body13pxMed" weight={null} colorScheme="black">
          새로고침
        </Typography>
      </Button>
    </S.Layout.ButtonWrap>
  </S.Layout.Wrap>
);

const NotFoundComponent = () => (
  <S.Layout.Wrap>
    <Typography variant="body14pxSemi" colorScheme="black">
      페이지를 찾을 수 없습니다.
    </Typography>
    <S.Layout.SubText>
      <Typography variant="body13pxReg" colorScheme="gray-600" style={{ whiteSpace: 'pre-line' }}>
        입력한 주소가 잘못되었거나 변경 혹은 삭제되어
        <br />
        요청하신 페이지를 찾을 수 없습니다.
      </Typography>
    </S.Layout.SubText>
    <S.Layout.ButtonWrap>
      <Button size={36} variant="secondary" onClick={() => window.AppInterface?.historyBack()}>
        <Typography size={null} variant="body13pxMed" weight={null} colorScheme="black">
          이전 페이지
        </Typography>
      </Button>
      <Button
        size={36}
        variant="secondary"
        onClick={() => (window.location.href = 'https://www.musinsa.com')}
      >
        <Typography size={null} variant="body13pxMed" weight={null} colorScheme="black">
          홈으로 이동
        </Typography>
      </Button>
    </S.Layout.ButtonWrap>
  </S.Layout.Wrap>
);

const S = {
  Layout: {
    Wrap: styled.div`
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      text-align: center;
      background-color: ${COLORS.gray[100]};
    `,
    SubText: styled.div`
      display: flex;
      flex-direction: column;
      margin-top: 4px;
    `,
    ButtonWrap: styled.div`
      margin-top: 12px;

      button + button {
        margin-left: 8px;
      }
    `,
  },
  Api: {
    Wrap: styled.article<{ $cssProperties?: CSSProperties }>`
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 254px;
      background-color: #f3f3f3;
      ${({ $cssProperties }) => $cssProperties && { ...$cssProperties }}
    `,
  },
};

export { NotFound, ApiErrorComponent, GlobalErrorComponent, NotFoundComponent };
